import './ui.css';
import Alert from './Alert';
import Button from './Button';

/**
 * 頁面級錯誤呈現。組合 Alert + Button；不承載 feature domain。
 * retry 僅在 retryable 且提供 onRetry 時顯示。
 */
export default function ErrorState({
  title,
  description,
  retryable = false,
  retryLabel = 'Retry',
  onRetry,
  compact = false,
  supportCode,
  className = '',
  ...rest
}) {
  const showRetry = Boolean(retryable && typeof onRetry === 'function');

  return (
    <Alert
      variant="error"
      className={`ui-error-state ${compact ? 'ui-error-state--compact' : ''} ${className}`.trim()}
      title={title}
      actions={
        showRetry ? (
          <Button type="button" variant="secondary" onClick={onRetry} data-testid="ui-error-retry">
            {retryLabel}
          </Button>
        ) : null
      }
      {...rest}
    >
      {description ? <p className="ui-error-state__description">{description}</p> : null}
      {supportCode ? (
        <p className="ui-error-state__support" data-testid="ui-error-support-code">
          {supportCode}
        </p>
      ) : null}
    </Alert>
  );
}
